<div class="two-factor-setup">
    <app-slide-toggle
        (valueChange)="emit_enabled_change($event)"
        [disabled]="toggleDisabled$$()"
        [label]="toggleLabel$$()"
        [value]="enabled$$()"
    />

    @switch (viewState$$()) {
        @case ('status') {}
        @case ('enrolling') {
            @if (keyExisting$$()) {
                <p>Vul de code in van het Reflecs-account dat al in je authenticator-app staat.</p>
            } @else {
                <p>
                    Scan deze QR-code met je authenticator-app (bv. Google Authenticator of Authy),
                    of voer de code hieronder handmatig in.
                </p>
            }
            @if (qrCodeDataUrl$$(); as qr) {
                <img class="qr-code" [src]="qr" alt="QR-code voor authenticator-app" />
            }
            @if (secret$$(); as secret) {
                <p class="secret">{{ secret }}</p>
            }
            <form id="two-factor-enroll-form" [formGroup]="EnrollForm" autocomplete="off" (keyup.enter)="emit_confirmEnroll()">
                <app-input-control [htmlAutocomplete]="'one-time-code'"
                    [autofocus]="true"
                    [control]="EnrollFormControls.code"
                    [label]="'code'"
                    [lockOnLoad]="true"
                    [placeholder]="'6-cijferige code'"
                    [showError]="showErrors || EnrollForm.touched"
                    [tabIndex]="'0'"
                    [type]="'text'" />
            </form>
            <app-buttons-row>
                <app-button-action form="two-factor-enroll-form" (btnClick)="emit_confirmEnroll()">bevestigen</app-button-action>
                <app-button-action (btnClick)="emit_cancelEnroll()">annuleren</app-button-action>
            </app-buttons-row>
            @if (keyExisting$$()) {
                <p class="hint">
                    Account niet meer in je app, telefoon kwijt of twijfel over de veiligheid? Maak een
                    nieuwe sleutel aan (met QR-code); het oude account in je authenticator-app werkt dan
                    niet meer.
                </p>
                <app-buttons-row>
                    <app-button-action (btnClick)="emit_enroll(true)">nieuwe sleutel</app-button-action>
                </app-buttons-row>
            }
        }
        @case ('confirming') {
            <p class="hint">
                Domains die tweestapsverificatie vereisen, zijn na uitschakelen niet meer toegankelijk.
                Je wordt overal uitgelogd. Het account in je authenticator-app blijft geldig voor als je
                het later weer inschakelt.
            </p>
            <p>Vul je huidige wachtwoord in ter bevestiging.</p>
            <form id="two-factor-disable-form" [formGroup]="DisableForm" autocomplete="off" (keyup.enter)="emit_confirmDisable()">
                <app-input-control [htmlAutocomplete]="'current-password'"
                    [autofocus]="true"
                    [control]="DisableFormControls.password"
                    [label]="'wachtwoord'"
                    [lockOnLoad]="true"
                    [placeholder]="'huidig wachtwoord'"
                    [showError]="showErrors || DisableForm.touched"
                    [tabIndex]="'0'"
                    [type]="'password'" />
            </form>
            <app-buttons-row>
                <app-button-action form="two-factor-disable-form" (btnClick)="emit_confirmDisable()">uitschakelen bevestigen</app-button-action>
                <app-button-action (btnClick)="emit_cancelDisable()">annuleren</app-button-action>
            </app-buttons-row>
        }
    }
</div>
